import Base from './Base';
import RecurringBroadcast from '../models/RecurringBroadcast';

export default class RecurringBroadcasts extends Base {
    get models() {
        const collection = this.data.map(item => new RecurringBroadcast(item));
        collection.collection = this;

        return collection;
    }
}
